export const markerConstants: Record<string, string> = {
    alert: 'https://sharepomco.s3.amazonaws.com/PublicImages/alert_dot_icon.png',
    device: 'https://sharepomco.s3.amazonaws.com/PublicImages/device_dot_icon.png',
    report: 'https://sharepomco.s3.amazonaws.com/PublicImages/report_dot_icon.png',
    safetyReport: 'https://sharepomco.s3.amazonaws.com/PublicImages/check_on_me_dot.png',
    userMobileLocation: 'https://sharepomco.s3.amazonaws.com/PublicImages/device_dot_icon.png',
    multiple: 'https://sharepomco.s3.amazonaws.com/PublicImages/hot_pink_multiple_events.png'
};

export const markerRadiusColorConstants: Record<string, string> = {
    alert: '#FF0000',
    device: '#762A83',
    userMobileLocation: '#762A83',
    report: '#081C63',
    safetyReport: '#FCC419',
    multiple : '#FF1393'
};